"use client"
import Link from "next/link";
import { useRouter } from "next/navigation";
import { useAppDispatch } from "lib/redux/hooks";
import { setImportComponentOpen } from "lib/redux/settingsSlice";
import { ArrowLongRightIcon } from "@heroicons/react/24/outline";
import { StarIcon } from "@heroicons/react/24/solid";
import FacebookIllustration from "public/assets/heroIllustrations/facebookIllustration.svg";
import AmazonIllustration from "public/assets/heroIllustrations/amazonIllustration.svg";
import AirBnbIllustration from "public/assets/heroIllustrations/airbnbIllustration.svg";
import GoogleIllustration from "public/assets/heroIllustrations/googleIllustration.svg";
import NetflixIllustration from "public/assets/heroIllustrations/netflixIllustration.svg";
import HeroResumeIllustration from "public/assets/heroIllustrations/heroResumeIllustration.svg";
import GradientIllustration from "public/assets/heroIllustrations/gradientIllustration.svg";
import NewCircles from "public/assets/heroIllustrations/newCircles.svg";
import HeroBgPattern from "public/assets/heroIllustrations/heroBgPattern.svg";
import FreeText from "public/assets/heroIllustrations/freeText.svg";
import AutofillBlackIcon from "public/assets/AutofillBlackIcon.svg";
import GetResumeScoreIcon from "public/icons/getResumeScore.svg"
import { cx } from "lib/cx";
import usersImage from "public/assets/heroIllustrations/usersImage.webp";
import atsImage from "public/assets/heroIllustrations/atsImage.webp";
import testimonialImage from "public/assets/heroIllustrations/testimonialImage.webp";
import Image from "next/image";
import { setIsAuthenticationOpen } from "lib/redux/uiSlice";
import { useEffect, useState } from "react";

export const Hero = () => {
  const router = useRouter();
  const [accessToken, setAccessToken] = useState<string | null>(null);
  const dispatch = useAppDispatch();

  useEffect(() => {
    // Access localStorage only on the client side after component mounts
    const token = localStorage.getItem("access-token");
    setAccessToken(token);
  }, []);
  
  const handleResumeImport = () => {
    dispatch(setImportComponentOpen(true));
    router.push("/resume-builder");
  };
  const handleCheckScore = () =>{
   
    router.push("/upload-resume");
  }
  return (
    <section className="hidden overflow-hidden bg-[#F9F9F9] px-8 font-montserrat lg:block lg:h-[calc(100vh-80px)]">
      <div className="relative">
        <div className="flex w-fit flex-col pt-12 text-[#3A3A3A] md:gap-4 lg:gap-6 xl:gap-9">
          <h1 className="hero-h1 font-medium leading-[2.35rem] tracking-tight">
            <span className="text-reveal line-1">
              <span className="text-[#52A1FF]">Enhance</span> Your Existing
              Resume
            </span>
            <br />
            <span className="text-reveal line-2">
              Or <span className="text-[#52A1FF]">Generate</span> New Resume
            </span>
            <br />
            <span className="text-reveal line-3 flex items-center">
              For{" "}
              <FreeText className="inline-block h-[27px] w-[38px] lg:h-[36px] lg:w-[51px] xl:h-[45px] xl:w-[64px] 2xl:h-[53px] 2xl:w-[76px]" />
            </span>
          </h1>
          <h2 className="hero-p font-light">
            <span className="text-reveal line-1">
              Professional resume with no hassle.
            </span>
            <br />
            <span className="text-reveal line-2">
              A straight-forward, no-fluff resume builder.
            </span>
            <br />
            <span className="text-reveal line-2">No credit card required.</span>
          </h2>
          <div className="fade-in-navbar flex gap-7 text-xs lg:text-sm xl:text-base">
            <Link href="/resume-builder" className="btn-gradient rounded-[40px] px-4 py-1 font-poppins lg:py-2 xl:px-8">
              {/* <button className="btn-gradient rounded-[40px] px-4 py-1 font-poppins lg:py-2 xl:px-8"> */}
                Generate Now <ArrowLongRightIcon className="h-6 w-6" />
              {/* </button> */}
            </Link>
            <Link href="/upload-resume"
              className="flex items-center gap-2 rounded-[40px] px-4 py-1 font-poppins shadow-lg lg:py-2 xl:px-8"
              // onClick={handleCheckScore}
            >
              Get Resume Score <GetResumeScoreIcon className="h-6 w-6" />
            </Link>
          </div>
          <div className="flex items-center">
            <FacebookIllustration
              className={cx(
                "fade-in-left-hero del-1",
                "h-auto md:w-[57px] lg:w-[63px]"
              )}
            />
            <AmazonIllustration
              className={cx(
                "fade-in-left-hero del-2 -ml-5",
                "h-auto md:w-[57px] lg:w-[63px]"
              )}
            />
            <AirBnbIllustration
              className={cx(
                "fade-in-left-hero del-3 -ml-3",
                "h-auto md:w-[57px] lg:w-[63px]"
              )}
            />
            <GoogleIllustration
              className={cx(
                "fade-in-left-hero del-4 -ml-4",
                "h-auto md:w-[57px] lg:w-[63px]"
              )}
            />
            <NetflixIllustration
              className={cx(
                "fade-in-left-hero del-5 -ml-4",
                "h-auto md:w-[57px] lg:w-[63px]"
              )}
            />
          </div>
          <div className="fade-in-navbar text-[#3C3C3C]">
            <div className="flex gap-1">
              <StarIcon className="h-5 w-5 text-[#FFC700]" />
              <StarIcon className="h-5 w-5 text-[#FFC700]" />
              <StarIcon className="h-5 w-5 text-[#FFC700]" />
              <StarIcon className="h-5 w-5 text-[#FFC700]" />
              <div className="font-medium">4.5</div>
            </div>
            <div className="text-xs">Rated by FAANG employees</div>
          </div>
        </div>
        {/* ANIMATED ILLUSTRATIONS */}
        <div className="absolute right-0 top-0 h-full w-1/2">
          <GradientIllustration className="absolute 2xl:-right-11" />
          <HeroBgPattern className="absolute right-2" />

          <NewCircles className="rotating-circle absolute right-3 top-2 h-auto w-[490px] xl:w-[583px]" />

          <HeroResumeIllustration
            className={cx(
              "fade-in-top-hero absolute right-16 top-6",
              "h-[288px] w-[200px] md:h-[360px] md:w-[250px] lg:h-[432px] lg:w-[300px] xl:h-[513px] xl:w-[355px] 2xl:h-[576px] 2xl:w-[400px]"
            )}
          />

          <div
            className={cx(
              "fade-in-diagonal-left absolute right-32 top-16",
              "md:h-[107px] md:w-[320px] lg:h-[120px] lg:w-[360px] xl:h-[147px] xl:w-[442px] 2xl:h-[167px] 2xl:w-[500px]"
            )}
          >
            <Image
              src={usersImage}
              alt="heroImg"
              fill={true}
              priority
              fetchPriority="high"
              sizes="(min-width:1280px) 33vw, (min-width:768px) 40vw, 60vw"
            />
          </div>

          <div
            className={cx(
              "fade-in-diagonal-right absolute right-0 top-52",
              "h-[190px] w-[150px] md:h-[254px] md:w-[200px] lg:h-[305px] lg:w-[240px] xl:h-[363px] xl:w-[286px] 2xl:h-[406px] 2xl:w-[320px]"
            )}
          >
            <Image
              src={atsImage}
              alt="heroImg"
              fill={true}
              priority
              fetchPriority="high"
              sizes="(min-width:1280px) 18vw, (min-width:768px) 22vw, 30vw"
            />
          </div>

          <div
            className={cx(
              "fade-in-diagonal-left absolute right-52 top-44",
              "h-[190px] w-[240px] md:h-[270px] md:w-[340px] lg:h-[317px] lg:w-[400px] xl:h-[384px] xl:w-[484px] 2xl:h-[444px] 2xl:w-[560px]"
            )}
          >
            <Image
              src={testimonialImage}
              alt="heroImg"
              fill={true}
              priority
              fetchPriority="high"
              sizes="(min-width:1280px) 40vw, (min-width:768px) 45vw, 70vw"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
